import { cn } from '@/lib/utils';

/**
 * Shell: card surface + border, shared width transition (collapsible rail).
 * Off-canvas drawer below `md` (slides via translate-x, toggled per-layout); back to a normal
 * in-flow, width-transitioning rail at `md:` and up.
 */
export const APP_SIDEBAR_ASIDE_CLASS =
    'fixed inset-y-0 left-0 z-40 flex shrink-0 flex-col overflow-hidden border-r border-border bg-card ' +
    'transition-transform duration-300 ease-out md:static md:z-auto md:translate-x-0 md:transition-[width]';

/** Top strip under header (collapse / expand controls). */
export const APP_SIDEBAR_HEADER_ROW_CLASS = 'flex min-h-[3rem] shrink-0 items-center border-b border-border';

/** Collapse / expand control — always matches sidebar surface. */
export const APP_SIDEBAR_TOGGLE_BUTTON_CLASS =
    'flex h-9 w-9 items-center justify-center rounded-lg border border-border bg-card text-foreground shadow-sm transition hover:border-primary-300 hover:bg-muted';

export function appSidebarNavClassName(expanded) {
    return cn(
        'min-w-0 flex-1 space-y-2 overflow-y-auto overflow-x-hidden',
        expanded ? 'p-4 pt-3' : 'flex flex-col items-center space-y-2 p-2 pt-3',
    );
}

/** “Navigation” section label above links. */
export const APP_SIDEBAR_SECTION_LABEL_CLASS =
    'mb-2 px-2 text-xs font-bold uppercase tracking-wider text-muted-foreground';

/**
 * Active: primary accent + left border when expanded (matches Member / Project Manager).
 * Inactive: muted + hover surface.
 */
export function appSidebarNavLinkClassName({ isActive, expanded }) {
    return cn(
        'flex items-center rounded-md font-medium transition-colors',
        expanded
            ? 'gap-3.5 px-3 py-2.5 text-base'
            : 'justify-center p-2.5',
        isActive
            ? cn(
                'bg-transparent text-primary-700 dark:text-primary-300',
                expanded ? 'border-l-4 border-primary-500/80 pl-3' : 'border-l-0',
            )
            : 'text-muted-foreground hover:bg-muted hover:text-foreground',
    );
}

/** DashboardLayout (legacy) — slightly smaller type, same color semantics. */
export function dashboardSidebarNavLinkClassName({ isActive, expanded }) {
    return cn(
        'flex items-center rounded-md font-medium transition-colors text-sm',
        expanded ? 'gap-3 px-3 py-2' : 'justify-center p-2.5',
        isActive
            ? cn(
                'bg-transparent text-primary-700 dark:text-primary-300',
                expanded ? 'border-l-4 border-primary-500/80 pl-3' : 'border-l-0',
            )
            : 'text-muted-foreground hover:bg-muted hover:text-foreground',
    );
}
